// extracted by mini-css-extract-plugin
export default {"sideNavigatorWrapper":"VCnZF89G2bbbRDTwK7eA","navigatorItem":"RAwTnlmgiLHLCYfvRQhz","selected":"uuLwhj_qMYLDONAwQ78F"};